<template>
	<section v-if="items.length" class="main-content contentblocks">
		<slot name="blocks-header" />
		<content-block
			v-for="item in items"
			:key="item.ID"
			:image="item.image"
			:image-webp="item.imageWebp ?? ''"
			:image-alt="item.imageAlt ?? ''"
			:header="item.header"
			:video="item.embedCode"
			:content="item.content"
			class="row contentblock"
		/>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background: var(--primary-background-color);
	padding: 75px 0 0;
}

.subpage .contentblocks {
	padding: 25px 0 0;
}
</style>
